const server = 'https://analytics.altavia-act.com/piwik'
const siteId = 2
let isLoaded = false

export function loadMatomo(callback = null) {
  window._paq = window._paq || []
  var _paq = window._paq

  // tracker methods like "setCustomDimension" should be called before "trackPageView"
  _paq.push(['setDoNotTrack', false])
  _paq.push(['disableCookies'])
  _paq.push(['trackPageView'])
  _paq.push(['enableLinkTracking'])
  _paq.push(['setTrackerUrl', server + '.php'])
  _paq.push(['setSiteId', siteId])

  if (isLoaded) { return }

  const d = document
  const s = d.createElement('script')

  s.src = server + '.js'
  s.async = false
  s.defer = true
  s.onload = () => {
    isLoaded = true

    if(callback) {
      callback.call()
    }
  }

  d.body.appendChild(s)
}



// WEBPACK FOOTER //
// ./resources/js/modules/Metrics/loader.js